//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const uid = () => Math.random().toString(36).substring(2);

var script = {
  name: 'ContentLoader',
  props: {
    speed: {
      type: Number,
      default: 2
    },
    preserveAspectRatio: {
      type: String,
      default: 'none'
    },
    baseUrl: {
      type: String,
      default: ''
    },
    primaryColor: {
      type: String,
      default: '#f9f9f9'
    },
    secondaryColor: {
      type: String,
      default: '#ecebeb'
    },
    primaryOpacity: {
      type: Number,
      default: 1
    },
    secondaryOpacity: {
      type: Number,
      default: 1
    },
    uniqueKey: {
      type: String,
      default: ''
    },
    animate: {
      type: Boolean,
      default: true
    },
    viewBox: {
      type: String,
      default: undefined
    },
    width: {
      type: [String, Number],
      default: '300px'
    },
    height: {
      type: [String, Number],
      default: '20px'
    }
  },
  computed: {
    fill() {
      return {
        fill: `url(${this.baseUrl}#${this.idGradient})`
      };
    },

    idClip() {
      return this.uniqueKey ? `${this.uniqueKey}-idClip` : uid();
    },

    idGradient() {
      return this.uniqueKey ? `${this.uniqueKey}-idGradient` : uid();
    },

    clipPath() {
      return `url(${this.baseUrl}#${this.idClip})`;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ContentLoader/ContentLoader.vue_rollup-plugin-vue=script.js